import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { PreviewWithDataErrorMessage } from '../../common/types';
import { PushActionButton } from '../../../graphql';

export interface PushPreviewContextState {
  isLoading: boolean;
  messageAttachmentUrlAndroid: string;
  messageAttachmentUrlIos: string;
  messageContentBody: string;
  messageContentTitle: string;
  messageActionButtons: PushActionButton[];
  messageRawDataPayload: string;
  onRefreshPreview: NoOp;
  previewError?: PreviewWithDataErrorMessage;
}

export const PushPreviewContext = createContext<PushPreviewContextState>({
  isLoading: false,
  messageAttachmentUrlAndroid: '',
  messageAttachmentUrlIos: '',
  messageContentBody: '',
  messageContentTitle: '',
  messageActionButtons: [],
  messageRawDataPayload: '{}',
  onRefreshPreview: noop,
  previewError: undefined,
});

export const usePushPreviewContext = () => useContext(PushPreviewContext);
